import apiFetch from '../apiFetch'

export default function (idCentro, token) {
  return apiFetch({endPoint: `Usuario/putCambiarCentro?idCentro=` + idCentro, method: 'GET', body: null, token: token})
}